(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["chadash-process-milling-work"]) return;
  try {
    
$(function() {
		$('.pop').on('click', function() {
			$('.imagepreview').attr('src', $(this).find('img').attr('src'));
			$('#imagemodal').modal('show');   
		});		
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chadash-process-the-finishing-work"]) return;
  try {
    
$(function() {
		$('.pop').on('click', function() {
			$('.imagepreview').attr('src', $(this).find('img').attr('src'));
			$('#imagemodal').modal('show');   
		});		
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chadash-process-the-metal-work"]) return;
  try {
    
$(function() {
		$('.pop').on('click', function() {
			$('.imagepreview').attr('src', $(this).find('img').attr('src'));
			$('#imagemodal').modal('show');   
		});		
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chadash-process-the-tools"]) return;
  try {
    
$(function() {
		$('.pop').on('click', function() {
			$('.imagepreview').attr('src', $(this).find('img').attr('src'));
			$('#imagemodal').modal('show');   
		});		
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chadash-process-the-wood"]) return;
  try {
    
$(function() {
		$('.pop').on('click', function() {
			$('.imagepreview').attr('src', $(this).find('img').attr('src'));
			$('#imagemodal').modal('show');   
		});		
});

  } catch(e) { console.error(e); }
})();

})();
